import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosInstance } from 'axios';
import { WifiNetworkState, WifiNetworkEntity } from './types';
import { DataPayload, SortPayloadAction, EntityState } from '../types';
import WifiNetworksApi from '../../api/wifiNetworksApi';

const initialState: WifiNetworkState = {
  data: [],
  currentPage: 0,
  resultsPerPage: 8,
  totalPages: 1,
  sortColumn: 'ssid',
  sortDirection: 1,
  selectedFilters: {},
};

const wifiNetworksSlice = createSlice({
  name: 'wifiNetworks',
  initialState,
  reducers: {
    setWifiNetworks: (
      state,
      { payload }: PayloadAction<DataPayload<WifiNetworkEntity>>
    ) => {
      state.data = payload.entities;
      state.totalPages = payload.totalPages;
    },
    sortWifiNetworks: (
      state,
      { payload }: SortPayloadAction<WifiNetworkEntity>
    ) => {
      state.sortColumn = payload.column;
      state.sortDirection = payload.direction;
      state.currentPage = initialState.currentPage;
      state.data = initialState.data;
    },
    setCurrentPage: (state, { payload }: PayloadAction<number>) => {
      state.currentPage = payload;
    },
    setSearchFilter: (state, { payload }: PayloadAction<string>) => {
      state.selectedFilters = {
        ...state.selectedFilters,
        search: payload,
      };
      state.currentPage = initialState.currentPage;
      state.data = initialState.data;
    },
    resetWifiNetworkState: () => initialState,
  },
});

export const loadWifiNetworks = async (
  axios: AxiosInstance,
  companyId?: string,
  state?: EntityState<WifiNetworkEntity>
) => {
  if (!companyId) {
    return setWifiNetworks({ entities: [], totalPages: 0 });
  }

  if (!state) {
    state = initialState;
  }

  const response = await WifiNetworksApi.getWifiNetworks(axios, companyId, {
    search: state.selectedFilters?.search,
  });

  return setWifiNetworks(response);
};

export const {
  setWifiNetworks,
  sortWifiNetworks,
  setCurrentPage,
  setSearchFilter,
  resetWifiNetworkState,
} = wifiNetworksSlice.actions;

export default wifiNetworksSlice.reducer;
